module.exports = __webpack_public_path__ + "static/media/YM13_0.9b9957e8.jpg";